import React, { MutableRefObject } from "react";
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import { useDialog, DialogsContextProps } from "../providers/dialogs";
import { useSnackBar } from "../providers/snackbar";
import type { FeatureCollection } from 'geojson'
import { validateGeoJSON } from "../utils";
import { PlaceModel } from "../models/place";
import { TextField } from "@mui/material";


export interface EditAreaDialogProps {
    place: PlaceModel,
    value?: string;
    dialogProps?: Partial<DialogProps>
    title?: string
    placeholder?:string
}

export function EditAreaDialog(props: EditAreaDialogProps) {

    const title: string = props.title || "Editar area"
    const placeholder: string = props.placeholder || "Nombre"

    

    const [value, setValue] = React.useState<string>(props.value || '')
    const { dialogProps } = props;
    const dialog: DialogsContextProps = useDialog();
    const textRef: MutableRefObject<any> = React.useRef(null)
    const snackbar = useSnackBar()

    const cancel = () => {
        dialog.close()
    }

    const accept = () => {
        try {
            if (!value) {
                return
            }
            dialog.close(value)
        } catch (err) {
            snackbar.showError({ message: "Json invalido" })
            return
        }
    }

    const onChange = (value: string) => {
        setValue(value)
    }



    return (
        <Dialog
            sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: '80vh' } }}
            maxWidth="xs"
            TransitionProps={{}}
            open={true}
            {...dialogProps}
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent dividers>
                <TextField autoFocus value={value} onChange={(ev) => { onChange(ev.target.value) }} label={placeholder} variant="outlined" style={{ width: '90%' }} />
            </DialogContent>
            <DialogActions>
                <Button onClick={cancel}>Cancelar</Button>
                <Button onClick={accept}>Ok</Button>
            </DialogActions>
        </Dialog>
    );
}
